import React from 'react'

const IconCard = ({ description, image, title }) => {
  return (
    <div className="icon-card display--inline-block grid-cell">
      <img className="icon" alt={title} src={image} />
      <h3> {title} </h3>
      <div>
        <p>
          {description}
        </p>
      </div>
    </div>
  );
}

export default IconCard



// WEBPACK FOOTER //
// ./src/components/Home/IconCard.js